import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import Directions from "Assets/images/directions.svg";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  onClick: (e: any) => void;
  className?: string;
}
const DirectionsIcon: FC<Props> = memo(({ onClick, className = "" }: Props) => {
  const classes = createUseStyles(styles)();
  const click = (e: any) => {
    e.preventDefault();
    if (onClick) onClick(e);
  };
  return (
    <div title="Directions">
      <Directions
        id="directionsIcon"
        className={`${classes.pointer} ${className}`}
        onClick={click}
      />
    </div>
  );
}, areEqualShallow);
DirectionsIcon.defaultProps = {
  className: undefined,
};
export default DirectionsIcon;
